import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import Login from './components/Login';
import SpreadsheetLogin from './components/SpreadsheetLogin';
import Home from './components/Home';
import Setup2FA from './components/Setup2FA';
import Logout from './components/Logout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import UpdateProfile from './components/UpdateProfile';
import Navigation from './components/Navigation';
import People from './components/People';
import AddUser from './components/AddUser';
import Timeline from './components/Timeline';
import DocumentSigningDashboard from './components/DocumentSigningDashboard';
import TemplateDesigner from './components/signing/TemplateDesigner';
import PublicFormSigning from './components/signing/PublicFormSigning';
import EmployeesPanel from './components/EmployeesPanel';
import AuditLogViewer from './components/AuditLogViewer';
import DirectRequestsList from './components/DirectRequestsList';
import IndividualsPage from './components/IndividualsPage';
import { AuthProvider, AuthContext } from './components/AuthContext';
import { DesignerUIProvider } from './components/signing/DesignerUIContext';

// Create theme with Poppins font
const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 400 },
    button: { fontWeight: 500 }
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <LayoutWrapper>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/setup-2fa" element={<Setup2FA />} />
                <Route path="/signing/forms/:token" element={<PublicFormSigning />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/home" element={<Dashboard />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/individuals" element={<IndividualsPage />} />
                  <Route path="/people/:id" element={<People />} />
                  <Route path="/update-profile" element={<UpdateProfile />} />
                  <Route path="/add-user" element={<AddUser />} />
                  <Route path="/timeline" element={<Timeline />} />
                  <Route path="/signing" element={<DocumentSigningDashboard />} />
                  <Route path="/signing/templates/:id/design" element={<TemplateDesigner />} />
                  <Route path="/employees" element={<EmployeesPanel />} />
                  <Route path="/audit-logs" element={<AuditLogViewer />} />
                  <Route path="/requests" element={<DirectRequestsList />} />
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                </Route>
              </Routes>
            </LayoutWrapper>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

// Layout wrapper that handles the left sidebar navigation
const LayoutWrapper = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <div className="main-content">{children}</div>;
  }

  return (
    <DesignerUIProvider>
      <Navigation />
      <div className="main-content">
        {children}
      </div>
    </DesignerUIProvider>
  );
};

export default App;
